import { render, staticRenderFns } from "./FormContinentLocale.vue?vue&type=template&id=1e9f3249&scoped=true&"
import script from "./FormContinentLocale.vue?vue&type=script&lang=js&"
export * from "./FormContinentLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9f3249",
  null
  
)

export default component.exports